import { ClientGetRoomMessage, ClientGetRoomMessageResponse } from "../../proto/ClientGetRoomMessage_pb";
import store from "../../store";
import { addRoomMessages } from "../../store/messages/actions";
import BaseHandler from "../BaseHandler";

export default class HandleClientGetRoomMessageResponse extends BaseHandler<ClientGetRoomMessageResponse, ClientGetRoomMessage> {
  handle() {
    const clientGetRoomHistoryRequest = this.request?.toObject();
    const clientGetRoomMessageResponse = this.response.toObject();
    if (clientGetRoomHistoryRequest !== undefined && clientGetRoomMessageResponse.message !== undefined) {
      store.dispatch(
        addRoomMessages({
          roomId: clientGetRoomHistoryRequest.roomId,
          messageList: [clientGetRoomMessageResponse.message],
        })
      );
    }
  }
}
